export default {
    data: [{
        key: 'greenOrRedPercentage',
        name: 'Green or red percentage',
        function: 'value >= 0.8 ? GREEN : RED',
    }],
}
